import React, { useEffect, useState } from "react";
import Sidebar from "../components/EmployeeSidebar";
import EmployeeNavbar from "../components/EmployeeNavbar";
import { Box, useMediaQuery, useTheme, Snackbar, Alert, Card, CardContent, Typography, Button, Select, MenuItem, FormControl, InputLabel, Grid, TextField } from "@mui/material";
import ApiService from "../../../config/api";
import PropertyDetailsModal from "./PropertyDetailsModal";
import "./AssignedLeads.css";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import { ADD_COMMENT, CHANGE_STATUS, CREATE_QUERY } from "../../../config/api";
import { useNavigate } from "react-router-dom";


const AssignedLeads = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [sidebarOpen, setSidebarOpen] = useState(!isSmallScreen);
  const [assignedQueries, setAssignedQueries] = useState([]);
  const [filteredQueries, setFilteredQueries] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [comments, setComments] = useState({});
  const [statuses, setStatuses] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [showLeadForm, setShowLeadForm] = useState(false);
  const [leadData, setLeadData] = useState({
    name: "",
    email: "",
    number: "",
  });

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('accessToken');
    const body = {
      name,
      email,
      phone: number,
    };

    try {
      const response = await axios.post(CREATE_QUERY, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      setShowLeadForm(false);
      alert("Query submitted successfully!");
    } catch (error) {
      alert("Failed to submit query!");
    }
  };



  const handleCreateLeadClick = () => {
    setShowLeadForm((prev) => !prev);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLeadData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowLeadForm(false);
  };

  const toggleDrawer = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    const fetchAssignedQueries = async () => {
      try {
        const response = await ApiService.get("/admin/assignedQueries");

        const filteredData = response?.data?.assignedQueries.filter(query =>
          query.status !== "Failed" && query.status !== "Closed"
        );

        setAssignedQueries(filteredData);
        setFilteredQueries(filteredData);

        const initialStatuses = {};
        const initialComments = {};

        filteredData.forEach(query => {
          initialStatuses[query._id] = query.status || "Pending";
        });

        setStatuses(initialStatuses);
        setComments(initialComments);

      } catch (error) {
        console.error("Error fetching assigned queries:", error);
      }
    };

    fetchAssignedQueries();
  }, []);


  const handleStatusChange = async (queryId, event) => {
    const newStatus = event.target.value;

    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      [queryId]: newStatus,
    }));

    try {
      const token = localStorage.getItem('accessToken');
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await axios.put(
        `${CHANGE_STATUS}/${queryId}/status`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbarMessage('Status updated successfully');
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage('Error updating status');
      setSnackbarOpen(true);
    }
  };


  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);

    if (value) {
      const filtered = assignedQueries.filter(query =>
        query.comment && query.comment.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredQueries(filtered);
    } else {
      setFilteredQueries(assignedQueries);
    }
  };

  const handleFilterChange = (event) => {
    const selectedStatus = event.target.value;
    setStatusFilter(selectedStatus);

    if (selectedStatus) {
      const filtered = assignedQueries.filter(query => query.status === selectedStatus);
      setFilteredQueries(filtered);
    } else {
      setFilteredQueries(assignedQueries);
    }
  };

  const handlePropertyClick = async (propertyId) => {
    try {
      const response = await ApiService.get(`/admin/property/${propertyId}`);
      if (response.data.meta.property) {
        setSelectedProperty(response.data.meta.property);
        setModalOpen(true);
      } else {
        setSnackbarMessage("Property not found or deleted by admin");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Error fetching property details");
      setSnackbarOpen(true);
    }
  };

  const handleCommentChange = (queryId, event) => {
    const newComments = { ...comments, [queryId]: event.target.value };
    setComments(newComments);
  };


  const handleCommentSubmit = async (queryId, comment) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        console.error("Token not found in localStorage.");
        setLoading(false);
        return;
      }

      const response = await axios.post(
        ADD_COMMENT,
        { queryId, comment },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSnackbarMessage("Comment added successfully");
      setSnackbarOpen(true);
      setComments({ ...comments, [queryId]: "" });
    } catch (error) {
      setSnackbarMessage("Error adding comment");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedProperty(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box
      display="grid"
      gridTemplateColumns={sidebarOpen ? "200px 1fr" : "60px 1fr"}
      sx={{
        transition: "grid-template-columns 0.3s ease-in-out",
        overflow: "hidden",
      }}
    >
      <Sidebar open={sidebarOpen} toggleDrawer={toggleDrawer} setOpen={setSidebarOpen} />
      <div>
        <EmployeeNavbar />
        <div className="container mt-3">
          <div className="col-lg-12">
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              gap={2}
              sx={{ paddingBottom: '8px' }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "var(--bs-accent)",
                  borderColor: "var(--bs-primar)",
                  width: '15%',
                  color: "var(--bs-primary)",
                  "&:hover": {
                    backgroundColor: "var(--bs-accent)",
                  },
                  alignItems: "center",
                }}
                onClick={() => navigate("employee/assignedLeads")}
              >
                Website Leads
              </Button>
              <Button variant="contained"
                sx={{
                  backgroundColor: "transparent",
                  borderColor: "var(--bs-accent)",
                  width: '15%',
                  color: "var(--bs-primary)",
                  "&:hover": {
                    backgroundColor: "var(--bs-accent)",
                  },
                  alignItems: "center",
                }}
                onClick={() => navigate("/employeeAssignPhoneLead")}>
                Phone Leads

              </Button>
            </Box>
            <div className="col-lg-12 page-head rounded-2 d-flex justify-content-between align-items-center">

              {/* Status Filter  by Khalid */}

              <div className="status-filter-container">
                <FormControl size="small" fullWidth sx={{ width: '250px' }}>
                  <InputLabel>Status Filter</InputLabel>
                  <Select
                    value={statusFilter}
                    onChange={handleFilterChange}
                    label="Status Filter"
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Contacted">Contacted</MenuItem>
                    <MenuItem value="Site visited">Site visited</MenuItem>
                    <MenuItem value="Hold">Hold</MenuItem>
                    <MenuItem value="Failed">Failed</MenuItem>
                    <MenuItem value="Not interested">Not interested</MenuItem>
                    <MenuItem value="Interested">Interested</MenuItem>
                    <MenuItem value="Closed">Closed</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div className="search-input-container px-2">
                <input
                  type="text"
                  placeholder="Search by comment...."
                  className="form-control"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </div>

              {/* Create Lead Button  by Khalid */}

              <div className="create-lead-button px-2">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "var(--bs-accent)",
                    color: "var(--bs-primary)",
                    "&:hover": {
                      backgroundColor: "var(--bs-accent)",
                    },
                    alignItems: "center",
                  }}
                  onClick={handleCreateLeadClick}
                >
                  <PersonAddIcon className="me-2" />
                  {showLeadForm ? "Close Form" : "Create Lead"}
                </Button>
              </div>
            </div>
          </div>
          {showLeadForm && (
            <Box
              component="form"
              onSubmit={handleFormSubmit}
              sx={{
                marginTop: 3,
                padding: 2,
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Create New Lead
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Number"
                    name="number"
                    type="tel"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    required
                  />
                </Grid>
              </Grid>
              <Button
                type="submit"
                variant="contained"
                onClick={handleSubmit}
                color="success"
                sx={{ marginTop: 2 }}
              >
                Submit Lead
              </Button>
            </Box>
          )}

          <div className="row">
            {filteredQueries.length === 0 ? (
              <div className="col-12 mb-4">
                <Card>
                  <CardContent>
                    <Typography variant="h6" align="center">
                      No queries found.
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            ) : (
              filteredQueries.map((query) => (
                <div className="col-12 col-md-12 mb-4" key={query._id}>
                  <Card
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      boxShadow: 'none',
                      '&:hover': {
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <CardContent>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={8}>
                          <Typography variant="h6" component="div">
                            {query.queryId[0].name}
                          </Typography>

                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: '1.1rem' }}
                          >
                            {query.queryId[0].email} | +91 {query.queryId[0].phone}
                          </Typography>

                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: '1rem' }}
                          >
                            Created At : {new Date(query.queryId[0].createdAt).toLocaleString()}
                          </Typography>

                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: '1rem' }}
                          >
                            Priority : {query.priority}
                          </Typography>

                          {/* ⭐ Added Details */}
                          {query.queryId[0].budgetRange && (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontSize: '1rem' }}
                            >
                              Budget Range : {query.queryId[0].budgetRange}
                            </Typography>
                          )}

                          {query.queryId[0].purposeOfPurchase && (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontSize: '1rem' }}
                            >
                              Purpose : {query.queryId[0].purposeOfPurchase}
                            </Typography>
                          )}

                          {query.queryId[0].timelineToPurchase && (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontSize: '1rem' }}
                            >
                              Timeline : {query.queryId[0].timelineToPurchase}
                            </Typography>
                          )}

                          {query.queryId[0].siteVisitPreference && (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontSize: '1rem' }}
                            >
                              Site Visit : {query.queryId[0].siteVisitPreference}
                            </Typography>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={4} container direction="column" alignItems="flex-end">
                          {/* Status Dropdown */}
                          <FormControl size="small" fullWidth sx={{ marginBottom: 1 }}>
                            <InputLabel>Status</InputLabel>
                            <Select
                              value={statuses[query._id] || query.status || 'Pending'}
                              onChange={(e) => handleStatusChange(query._id, e)}
                              label="Status"
                              disabled={loading}
                            >
                              <MenuItem value="Pending">Pending</MenuItem>
                              <MenuItem value="Contacted">Contacted</MenuItem>
                              <MenuItem value="Site visited">Site visited</MenuItem>
                              <MenuItem value="Hold">Hold</MenuItem>
                              <MenuItem value="Failed">Failed</MenuItem>
                              <MenuItem value="Not interested">Not interested</MenuItem>
                              <MenuItem value="Interested">Interested</MenuItem>
                              <MenuItem value="Closed">Closed</MenuItem>
                            </Select>
                          </FormControl>

                          {/* Comment Input */}
                          <TextField
                            label="Add Comment"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={comments[query._id] || ''}
                            onChange={(e) => handleCommentChange(query._id, e)}
                            sx={{ marginBottom: 2 }}
                          />

                          {/* Action Buttons */}
                          <Grid container spacing={1} alignItems="center" direction="row">
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                  marginTop: 1,
                                  backgroundColor: '#122620',
                                  '&:hover': {
                                    backgroundColor: '#0e1f1f',
                                  },
                                }}
                                onClick={() =>
                                  handleCommentSubmit(query.queryId[0]._id, comments[query._id] || '')
                                }
                                disabled={loading}
                              >
                                {loading[query._id] ? <CircularProgress size={24} /> : 'Submit'}
                              </Button>
                            </Grid>

                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handlePropertyClick(query?.queryId?.[0]?.propertyId)}
                                disabled={!query?.queryId?.[0]?.propertyId}
                                sx={{
                                  marginTop: 1,
                                  backgroundColor: '#122620',
                                  '&:hover': {
                                    backgroundColor: '#0e1f1f',
                                  },
                                  '&.Mui-disabled': {
                                    backgroundColor: '#d3d3d3',
                                    color: '#888',
                                  },
                                }}
                              >
                                View Property Details
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </CardContent>

                  </Card>
                </div>
              ))
            )}
          </div>




        </div>
      </div>

      <PropertyDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        property={selectedProperty}
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AssignedLeads;
